<template>
  <div style="overflow: hidden;">
    <headers :title="libraryInfo.name+'大数据中心'"></headers>
    <div class="datasleft">
      <div class="notice">
        <p><img src="../../static/notice.png" alt="">通知公告：</p>
        <vue-seamless-scroll :data="dynamicsList" :class-option="optionLeft" class="seamless-warp2">
          <ul class="item">
            <li v-for="item in dynamicsList" v-text="item.title"></li>
          </ul>
        </vue-seamless-scroll>
      </div>
      <div class="operate" v-show="cur == true">
        <!-- <div class="operateTitle">运河书屋</div> -->
        <div class="total">
          <p>总馆藏量</p>
          <span v-for="(item,index) in totalcount" :key="index">{{item}}</span>
        </div>
        <div class="operateMain">
          <div class="operateMainItem">
            <p>总还书量</p>
            <span>{{zwInfo29.totalreturn}}</span>
          </div>
          <div class="operateMainItem">
          <p>总借书量</p>
          <span>{{zwInfo29.totallend}}</span>
          </div>
          <div class="operateMainItem">
          <p>总办证量</p>
            <span>{{zwInfo29.totalreader}}</span>
          </div>
          <div class="operateMainItem">
          <p>今日还书</p>
            <span>{{zwInfo30.totalreturn}}</span>

          </div>
          <div class="operateMainItem">
          <p>今日借书</p>
            <span>{{zwInfo30.totallend}}</span>

          </div>
          <div class="operateMainItem">
          <p>今日办证</p>
            <span>{{zwInfo30.totalreader}}</span>

          </div>
        </div>
      </div>
      <div class="operate" v-show="cur == false">
        <div class="operateTitle">借阅分类</div>
          <div class="echart" id="main1"></div>
      </div>

      <!-- <div class="operate">
        <div class="operateTitle">运河书屋总体的运营情况</div>
        <div class="operateMain">
          <p>
            总馆藏量
            <span>{{totalcount}}</span>
          </p>
          <p>
            总借书量
            <span>{{zwInfo29.totallend}}</span>
          </p>
          <p>
            总还书量
            <span>{{zwInfo29.totalreturn}}</span>
          </p>
          <p>
            总办证量
            <span>{{zwInfo29.totalreader}}</span>
          </p>
        </div>
      </div>
      <div class="operate">
        <div class="operateTitle">运河书屋今日的运营情况</div>
        <div class="operateMainTwo">
          <p>
            今日借书量
            <span>{{zwInfo30.totallend}}</span>
          </p>
          <p>
            今日还书量
            <span>{{zwInfo30.totalreturn}}</span>
          </p>
          <p>
            今日办证量
            <span>{{zwInfo30.totalreader}}</span>
          </p>
          <p>
            今日进馆人次
            <span>{{dayInCount}}</span>
          </p>
        </div>
      </div>-->
    </div>
    <!-- <div class="datasBox">
      <div class="datasBoxTitle">图书借阅</div>
      <div class="datasBoxMain">
        <p v-for="(item,index) in zwInfo21" :key="index" style="display:flex;padding:0 40px">
          <i style="margin-top:17px;">{{index+1}}</i>
          <span
            style="width:120px;display:block;overflow:hidden;margin-left:10px;white-space: nowrap;text-overflow: ellipsis;text-align:left;">{{item.title}}</span>
          <span>{{item.totallend}}</span>
        </p>
      </div>
    </div> -->
    <div style="clear: both;"></div>
    <!-- <div class="numDataWrap">
      <div class="numData">
        <div class="datasBoxTitle">历史总进馆人次</div>
        <p>{{allInCount}}</p>
      </div>
      <div class="numData">
        <div class="datasBoxTitle">本年度进馆人次</div>
        <p>{{yearInCount}}</p>
      </div>
    </div> -->
    <div class="bottomLfet">
      <div class="dataWrap">
        <p>历史进馆人次<span>{{allInCount}}</span></p>
        <p>本年进馆人次<span>{{yearInCount}}</span></p>
        <p>今日进馆人次<span>{{dayInCount}}</span></p>
      </div>
      <div class="datasBox">
        <div class="datasBoxTitle">图书借阅</div>
        <div class="datasBoxMain">
          <p v-for="(item,index) in zwInfo21" v-if="index<8" :key="index" style="display:flex;padding:0 20px">
            <i style="margin-top:10px;">{{index+1}}</i>
            <span class="boxspan">{{item.title}}</span>
            <span>{{item.totallend}}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="bookbox">
      <div class="alltitle">读书推荐</div>
      <div class="allMain">
        <!-- <div class="bookItem" v-if="index<5" v-for="(item,index) in recommendBookList" :key="index">
          <img :src="item.cover" alt />
        </div> -->
        <el-carousel indicator-position="none" :interval="5000" type="card"  @change="changeImgFn">
            <el-carousel-item v-for="(item,index) in recommendBookList" :key="index" :initial-index="index">
              <el-image  :src="item.cover" ></el-image>
            </el-carousel-item>

        </el-carousel>
      </div>
      <div class="bookRight" v-if="recommendBookList.length>0">
        <div class="bookTitle">{{recommendBookList[indexItem].bookName}}</div>
        <div class="booki">作者：{{recommendBookList[indexItem].author}}</div>
        <div class="booki">出版社：{{recommendBookList[indexItem].remarks}}</div>
        <div class="booki">类别：{{recommendBookList[indexItem].literatureType}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Carousel3d, Slide } from "vue-carousel-3d";
  const echarts = require("echarts");
  import {
    formatDate,
    getPreMonth
  } from '@/utils/date.js'
  import {
    getCategoryEntityData,
    getCategoryEntityAllYearData,
    getCategoryEntityYearData
  } from '@/api/anjisheng';
  import headers from "./headers.vue";
  import {
    listRecommendReadBooksPage,
    getLibraryDynamicsPage,
    getLibrary
  } from "@/api/study";
  import {
    getAjsHeaderInfo,
    getZwInfo
  } from "@/api/open";
  export default {
    components: {
      headers,
      Carousel3d,
      Slide,
    },
    computed: {
      optionLeft() {
        return {
          direction: 2,
          limitMoveNum: 2
        }
      }
    },
    data() {
      return {
        libraryId: null,
        filter: {
          currentPage: 1,
          pageSize: 10,
          libraryId: null
        },
        recommendBookList: [],
        dynamicsList: [],
        headerInfo: {},
        libraryInfo: {},
        zwForm: {
          libcode: null,
          ifcode: null,
          libid: null,
          rcount: null,
          ranktype: null,
          bdate: null,
          edate: null
        },
        totalcount: [],
        zwInfo29: {
          totallend: 11890,
          totalreturn: 11890,
          totalreader: 11890
        },
        zwInfo30: {
          totallend: 11890,
          totalreturn: 11890,
          totalreader: 11890
        },
        zwInfo21: [],
        zwInfo27: [],
        zwInfo27List: [{
            code: 'A',
            name: '基础类',
            value: 0
          },
          {
            code: 'B',
            name: '哲学',
            value: 0
          },
          {
            code: 'CDEFGHIJK',
            name: '社会科学',
            value: 0
          },
          {
            code: 'NQPQRSTUVX',
            name: '自然科学',
            value: 0
          },
          {
            code: 'Z',
            name: '综合类',
            value: 0
          }
        ],
        zwInfo27ClassList: ['基础类', '哲学', '社会科学', '自然科学', '综合类'],
        end: null,
        start: null,
        yearInCount: 9999,
        allInCount: 0,
        dayInCount:0,
        cur:false,
        indexItem:0,
      };
    },
    props:{
    		//默认激活下标
    		ind :{
    	      type : Number,
    	      default :0
    	    }
    },
    created() {
      this.initOrderCountDate();
      this.headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
      this.libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      this.zwForm.libcode = this.headerInfo.libcode;
      this.zwForm.libid = this.libraryInfo.libraryNo;
      // this.zwForm.libid = "103";
      this.getZwInfo24();
      this.getZwInfo29();
      this.getZwInfo30();
      this.getZwInfo21();
      this.getZwInfo27();
      if (this.$route.query.libraryId) {
        this.libraryId = this.$route.query.libraryId;
        this.filter.libraryId = this.libraryId;
      }
      this.getLibraryDynamics();
      this.getDayEntityData()
      this.getEntityYearData()
      this.getEntityAllYearData()
      this.getListRecommendBooks();;
    },
    mounted() {
      var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      var _this = this;
      this.timers = setInterval(() => {
        this.initOrderCountDate();
        this.getListRecommendBooks();
        this.getZwInfo24();
        this.getZwInfo29();
        this.getZwInfo30();
        this.getZwInfo21();
        this.getZwInfo27();
        this.getLibraryDynamics();
        this.getDayEntityData()
        this.getEntityYearData()
        this.getEntityAllYearData()
      }, 5 * 60 * 1000);
      this.timer = setInterval(()=>{
        this.cur = !this.cur
      },10*1000)
    },

    methods: {
      changeImgFn(ind){
        //console.log(ind)
        this.indexItem = ind
      },
      getDayEntityData() {
        var _this = this;
        getCategoryEntityData(this.libraryInfo.entityId).then(response => {

          _this.dayInCount = response.Data[0].DataIn;

        }).catch(error => {
          console.log(error);
        });
      },
      getEntityYearData() {
        var _this = this;
        getCategoryEntityYearData(this.libraryInfo.entityId).then(response => {


          _this.yearInCount = response.Data[response.Count - 1].DataIn;

        })
      },
      getEntityAllYearData() {
        var _this = this;
        getCategoryEntityAllYearData(this.libraryInfo.entityId).then(response => {

          var allIn = 0;
          
          for (var i = 0; i < response.Data.length; i++) {
            allIn = allIn + response.Data[i].DataIn
          }
          _this.allInCount = allIn;

        })
      },
      initData() {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById("main1"));
        // 绘制图表
        myChart.setOption({
          title: {
            x: "center" //x轴方向对齐方式
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            textStyle: {
              color: "#ffffff",
              fontSize:22,
              padding:[10,0,0,0]
            },
            type: 'scroll',
            orient: 'vertical',
            right: "right",
            right: 50,
            top: 20,
            bottom: 20,
            //data: ['文学','法学','财经','历史','医学','医学','医学','医学','医学','医学','医学','医学','医学','医学','医学','医学','医学','医学']
            data: this.zwInfo27ClassList
          },
          series: [{
            name: "分类",
            type: "pie",
            radius: "70%",
            center: ["40%", "50%"],
            // data:[
            //     {value:"335", name:'文学'},
            //     {value:"310", name:'法学'},
            //     {value:"234", name:'财经'},
            //     {value:"135", name:'历史'},
            //     {value:"1548", name:'医学'},

            // ],
            data: this.zwInfo27List,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            label: {
              fontWeight: "normal",
              fontSize: 16
            }
          }]
        });
      },
      getListRecommendBooks() {
        listRecommendReadBooksPage(this.filter).then(respone => {
          this.recommendBookList = respone.data.list;
          console.log(this.recommendBookList)
        });
      },
      getLibraryDynamics() {
        getLibraryDynamicsPage(this.filter).then(respone => {
          this.dynamicsList = respone.data.list;
          console.log('公告',respone.data.list)
        });
      },
      getOpenData() {
        getAjsHeaderInfo().then(response => {
          this.headerInfo = response.data;
        });
      },
      getLibraryInfo() {
        getLibrary(this.libraryId).then(response => {
          this.libraryInfo = response.data;
        });
      },
      getZwInfo24() {
        this.zwForm.ifcode = "10015";
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(this.zwForm));
        getZwInfo(this.headerInfo.zwUrl, params).then(respone => {
          var totalcount = respone.totalcount.split('');
          const totalLenght = totalcount.length
          if(totalLenght <9){
            for(var i=0;i<9-totalLenght;i++){
                totalcount.unshift("0")
            }
              this.totalcount = totalcount
          }

        });
      },
      getZwInfo29() {
        var _this = this;
        _this.zwForm.ifcode = "10020";
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(this.zwForm));
        getZwInfo(_this.headerInfo.zwUrl, params).then(respone => {
          _this.zwInfo29 = respone;
        });
      },
      getZwInfo30() {
        var _this = this;
        _this.zwForm.ifcode = "10021";
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(_this.zwForm));
        getZwInfo(_this.headerInfo.zwUrl, params).then(respone => {
          _this.zwInfo30 = respone;
        });
      },
      getZwInfo21() {
        var _this = this;
        _this.zwForm.ifcode = "10012";
        _this.zwForm.rcount = "10";
        _this.zwForm.ranktype = "M";
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(_this.zwForm));
        getZwInfo(_this.headerInfo.zwUrl, params).then(respone => {
          _this.zwInfo21 = JSON.parse(respone.datalist);
        });
      },
      getZwInfo27() {
        var _this = this;
        _this.zwForm.ifcode = "10018";
        _this.zwForm.bdate = _this.fomartDate(_this.start);
        _this.zwForm.edate = _this.fomartDate(_this.end);
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(_this.zwForm));
        getZwInfo(_this.headerInfo.zwUrl, params).then(respone => {
          _this.zwInfo27 = JSON.parse(respone.datalist);
          if (_this.zwInfo27.length > 0) {
            _this.zwInfo27.forEach(info => {

              for (var i = 0; i < _this.zwInfo27List.length; i++) {
                if (_this.zwInfo27List[i].code.indexOf(info.tclass) > -1) {
                  _this.zwInfo27List[i].value = _this.zwInfo27List[i].value + parseInt(info.tcount);
                }
              }
            });

          }
          _this.initData();

        });
      },
      /**
       * 初始化时间
       * @author liuqiyu
       */
      initOrderCountDate() {
        this.end = new Date();
        this.start = new Date();
        this.start.setTime(this.start.getTime() - 3600 * 1000 * 24 * 30);
      },
      /**
       * 时间格式化
       * @author liuqiyu
       */
      fomartDate(date) {
        let dt = new Date(date); //实例化时间对象
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate();
        //笨方法  return y + '-' + m + '-' + d
        //官方方法  注意引号，是tab键上面的符号（ES6的语法）
        return `${y}-${m}-${d}`;
      }
    },
    destroyed() {
      clearInterval(this.timers);
      clearInterval(this.bannerTime)
    },
  };
</script>

<style scoped="scoped">
  .datasleft {
    float: left;
    width: 48.75%;
    margin-top: 12px;
  }

  .operate {
    width: 100%;
    margin-bottom: 17px;
    margin-left: 1%;
    height: 516px;
    background: url(../../static/operate.png) no-repeat;
    background-size: 100% 100%;
    text-align: left;
    overflow: hidden;
  }

  .operateTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    margin-top: 12px;
    margin-left: 20px;
  }

  .operateMain {
    width: 100%;
    overflow: hidden;
  }
  .operateMainItem{
    width: 33.33%;
    float: left;
    text-align: center;
  }
  .operateMain p {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    margin-top: 70px;
  }

  .operateMain span {
    font-size: 50px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .operateMainItem:nth-child(1) span {
    color: #0DC9FF;
  }

  .operateMainItem:nth-child(2) span {
    color: #04CA96;
  }

  .operateMainItem:nth-child(3) span {
    color: #B900E7;
  }

  .operateMainItem:nth-child(4) span {
    color: #FE721D;
  }
  .operateMainItem:nth-child(5) span {
    color: #FF7E7E;
  }
  .operateMainItem:nth-child(6) span {
    color: #FFD40D;
  }
  .numDataWrap {
    width: 21.46%;
    overflow: hidden;
    float: left;
  }

  .numData {
    width: 100%;
    height: 173px;
    background: url(../../static/numData.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 12px;
    overflow: hidden;
  }

  .numData p {
    background: url(../../static/text2bg.png) no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 54px;
    line-height: 54px;
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #15c5ff;
    margin: 44px auto 0;
  }

  .datasBox {
    background: url(../../static/datasBox.png) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 276px;
    margin-top: 12px;
    overflow: hidden;
    float: left;
    margin-left: 1%;
  }

  .tablesBox {
    background: url(../../static/okbg.png) no-repeat;
    background-size: 100% 100%;
    width: 26.46%;
    height: 358px;
    margin-left: 1%;
    margin-top: 12px;
    overflow: hidden;
    float: left;
  }

  .notesBox {
    background: url(../../static/notesBox.png) no-repeat;
    background-size: 100% 100%;
    width: 15.89%;
    height: 358px;
    margin-left: 1%;
    margin-top: 12px;
    overflow: hidden;
    float: left;
  }

  .datasBoxTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    margin-left: 20px;
    margin-top: 12px;
    text-align: left;
  }
  .boxspan{
    width:350px;
    display:block;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align:left;
  }
  .datasBoxMain {
    width: 100%;
    overflow: hidden;
    margin-top: 10px;
  }

  .datasBoxMain p {
    line-height: 50px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: left;
    width: calc(50% - 80px);
  }
  .datasBoxMain p i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    font-style: normal;
    margin-right: 14px;
    padding: 0 2px;
    text-align: center;
  }

  .datasBoxMain p span {
    margin-left: 50px;
  }

  .datasBoxMain p:nth-child(1) i {
    background: #ffd40d;
  }

  .datasBoxMain p:nth-child(2) i {
    background: #ff9b0d;
  }

  .datasBoxMain p:nth-child(3) i {
    background: #5ed300;
  }

  .datasBoxMain p:nth-child(4) i {
    background: #0dc9ff;
  }

  .datasBoxMain p:nth-child(5) i {
    background: #772dff;
  }

  .datasBoxMain p:nth-child(6) i {
    background: #ff680d;
  }

  .datasBoxMain p:nth-child(7) i {
    background: #240dff;
  }

  .datasBoxMain p:nth-child(8) i {
    background: #ff0d7f;
  }

  .datasBoxMain p:nth-child(9) i {
    background: #24d8ff;
  }

  .datasBoxMain p:nth-child(10) i {
    background: #ff7b06;
  }

  .echart {
    width: 98%;
    margin: 0 auto;
    height: 500px;
  }

  .datasBoxNews {
    width: 248px;
    height: 254px;
    margin: 30px auto 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .newsItem {
    width: 90%;
    border-bottom: 1px dashed #ffffff;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin: 0 auto;
    text-align: left;
    padding: 20px 0;
  }

  .datasBoxNews::-webkit-scrollbar {
    width: 0px;
  }

  .datasBoxNews::-webkit-scrollbar-track {
    background-color: none;
  }

  .datasBoxNews::-webkit-scrollbar-thumb {
    background-color: none;
  }

  .datasBoxNews::-webkit-scrollbar-thumb:hover {
    background-color: none;
  }

  .datasBoxNews::-webkit-scrollbar-thumb:active {
    background-color: none;
  }

  .bookbox {
    background: url(../../static/minBg.png) no-repeat;
    background-size: 100% 100%;
    width: 48.75%;
    height: 355px;
    padding-bottom: 10px;
    overflow: hidden;
    float: left;
    margin-top: 5px;
    margin-left: 1.5%;
  }

  .alltitle {
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: left;
  }

  .allMain {
    width: 500px;
    margin: 0px auto 0;
    height: 280px;
    position: relative;
    float: right;
    margin-right: 50px;
  }

  .allMain::-webkit-scrollbar {
    width: 0px;
  }

  .allMain::-webkit-scrollbar-track {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb:hover {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb:active {
    background-color: none;
  }

  .bookItem {
    list-style: none;
    width: 160px;
    height: 214px;
    position: absolute;
    left: 0px;
    top: 27px;
    transition: all 0.3s ease;
  }

  .bookItem img {
    width: 100%;
    height: 100%;
  }

  .bookRight {
    float: left;
    margin-left: 40px;
    text-align: left;
    margin-top: 100px;
  }
  .p0 {
  	transform: translate3d(-80px, 0, 0) scale(1);
  	opacity: 0.3;
  	z-index: 1;
  }
  .p1 {
  	transform: translate3d(240px, 0, 0) scale(1);
  	opacity: 0.3;
  	z-index: 2;
  }

  .p2 {
  	transform: translate3d(160px, 0, 0) scale(1);
  	opacity: 0.8;
  	z-index: 3;
  }

  .p3 {
  	transform: translate3d(80px, 0, 0) scale(1.5);
  	opacity: 1;
  	z-index: 4;
  }

  .p4 {
  	transform: translate3d(0, 0, 0) scale(1);
  	opacity: 0.8;
  	z-index: 3;
  }
  .bookTitle {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .booki {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #15c5ff;
    line-height: 36px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .notice {
    width: 100%;
    height: 42px;
    overflow: hidden;
    margin-left: 1%;
  }

  .notice p {
    float: left;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    width: 160px;
  }
  .notice p img{
    width: 24px;
    height: 20px;
    margin-right: 11px;
    vertical-align: -2px;
  }
  .seamless-warp2 {
          overflow: hidden;
          height: 25px;
          width: calc(100% - 160px);
  }
  .item {
      width: 1080px;

  }
  .seamless-warp2 li {
      float: left;
      margin-right: 10px;
      list-style: none;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
      width: 33%;
  }
  .total{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  .total p{
    background: url(../../static/text1bg.png) no-repeat;
    background-size: cover;
    width: 213px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    font-size: 24px;
    font-family: Adobe Heiti Std;
    font-weight: bold;
    color: #0DC9FF;
  }
  .total span{
    display: block;
    background: url(../../static/numBg.png) no-repeat;
    background-size: cover;
    width: 46px;
    height: 54px;
    line-height: 54px;
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #0DC9FF;
    text-align: center;
    margin-left: 11px;
  }
  .bottomLfet{
    float: left;
    width: 48.75%;
    margin-top: 12px;
  }
  .dataWrap{
    width: 100%;
    display: flex;
    margin-left: 1%;
    height: 70px;
  }
  .dataWrap p{
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    flex: 1;
  }
  .dataWrap p span{
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #15C5FF;
  }
</style>
=======
  }
  .notice p img{
    width: 24px;
    height: 20px;
    margin-right: 11px;
    vertical-align: -2px;
  }
  .seamless-warp2 {
          overflow: hidden;
          height: 25px;
          width: 380px;
  }
  .item {
      width: 580px;

  }
  .seamless-warp2 li {
      float: left;
      margin-right: 10px;
      list-style: none;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
  }
  .total{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
  .total p{
    background: url(../../static/text1bg.png) no-repeat;
    background-size: cover;
    width: 213px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    font-size: 24px;
    font-family: Adobe Heiti Std;
    font-weight: bold;
    color: #0DC9FF;
  }
  .total span{
    display: block;
    background: url(../../static/numBg.png) no-repeat;
    background-size: cover;
    width: 46px;
    height: 54px;
    line-height: 54px;
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #0DC9FF;
    text-align: center;
    margin-left: 11px;
  }
  .bottomLfet{
    float: left;
    width: 48.75%;
    margin-top: 12px;
  }
  .dataWrap{
    width: 100%;
    display: flex;
    margin-left: 1%;
    height: 70px;
  }
  .dataWrap p{
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    flex: 1;
  }
  .dataWrap p span{
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #15C5FF;
  }
</style>

>>>>>>> 7bb88c0791d7a747fe4f0eb9464bd13a4a2aa2a8



// WEBPACK FOOTER //
// src/components/datas.vue